export default function() {
    return {
        items: {
            data: [],
            columns: [
                { name: 'CUSTOMER', align: 'left', label: "CUSTOMER", field: row =>row.company,  },
                { name: 'COACHING TRACK', align: 'left', label: "COACHING TRACK", field: row =>row.company,  },
                { name: 'SESSION DATE', align: 'left', label: "SESSION DATE", field: row =>row.company,  },
                { name: 'START TIME', align: 'left', label: "START TIME", field: row =>row.company,  },
                { name: 'STATUS', align: 'left', label: "STATUS", field: row =>row.company,  },
                { name: 'IMPACT SURVEY RESULTS', align: 'left', label: "IMPACT SURVEY RESULTS", field: row =>row.company,  },



            ],
            pagination: {
                sortBy: '',
                descending: false,
                page: 1,
                rowsPerPage: 10,
                totalRecords: 0
            },
            filter: {
                search: "",
                customers: [],
                status: null,
                pickerDates: {
                    startDate: "",
                    endDate: "",
                  },
            },
            lastUpdated: '',
        }
    }
}
